<template>
  <div class="text-box">
    <div class="text" :style="{color: textColor}" :color="textColor">{{ text }}</div>
    <div class="icon" :style="{'background-color': iconColor}">
      <Icon color="white" :type="iconType" size="12"/>
    </div>
  </div>
</template>

<script>
export default {
  name: "TextWithCornerIcon",
  props: ["text", "type"],
  data() {
    return {};
  },
  computed: {
    iconColor: function () {
      switch (this.type) {
        case "ok":
          return 'darkgreen'
        case "wrong":
          return 'darkred'
      }
      return;
    },
    iconType: function () {
      switch (this.type) {
        case "ok":
          return 'md-checkmark'
        case "wrong":
          return 'md-close'
      }
      return;
    },
    textColor: function () {
      switch (this.type) {
        case "ok":
          return 'darkgreen'
        case "wrong":
          return 'darkgray'
      }
      return;
    },
  },
};
</script>
<style lang="stylus" scoped>
.text-box
  position: relative;
  padding: 0 4px 2px 0;
  cursor pointer

.icon
  position: absolute;
  bottom: 0px;
  right: 0px;
  height: 12px;
  display: flex;
  border-radius: 6px;
</style>